module.exports = __webpack_public_path__ + "img/grip-vertical.78f00cda.svg";